<template>
  <div class="animated fadeIn">
    <div id="accueil-rpa">
      <b-row class="row-stats">
        <b-col md="12">
          <b-row>
            <b-col class="md-6 sm-12">
              <b-card>
                <div class="callout callout-success">
                  <strong class="text-muted">Virements en cours</strong><br>
                  <span class="h5">{{ indicateurs.SumVirementEnCours == null ? 0 : formatNumber(indicateurs.SumVirementEnCours) }} €</span><br>
                  <span class="text-muted">Plus ancien : {{ formatDate(indicateurs.dateDernierVirementEnCours) }}</span><br>
                </div>
              </b-card>
            </b-col>
            <b-col class="md-6 sm-12">
              <b-card>
                <div class="callout callout-primary">
                  <strong class="text-muted">Télérèglement en cours</strong><br>
                  <span class="h5">{{ indicateurs.SumTelereglementEnCours == null ? 0 : formatNumber(indicateurs.SumTelereglementEnCours) }} €</span><br>
                  <span class="text-muted">Plus ancien : {{ formatDate(indicateurs.dateDernierTelereglementEnCours) }}</span><br>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="md-3 sm-12">
              <b-card>
                <div class="callout callout-success">
                  <strong class="text-muted">Virements encaissés sur {{ new Date().getFullYear() }}</strong><br>
                    <span class="text-muted">Traités : </span><span class="h5">{{ formatNumber(indicateurs.countVirementTraite) }}</span><br>
                    <span class="text-muted">Montant : </span><span class="h5 text-nowrap">{{ formatNumber(indicateurs.sumVirementTraite) }} €</span>
                </div>
              </b-card>
            </b-col>
            <b-col class="md-3 sm-12">
              <b-card>
                <div class="callout callout-primary">
                  <strong class="text-muted">Télérèglements encaissés sur {{ new Date().getFullYear() }}</strong><br>
                    <span class="text-muted">Traités : </span><span class="h5">{{ formatNumber(indicateurs.countTelereglementTraite) }}</span><br>
                    <span class="text-muted">Montant : </span><span class="h5 text-nowrap">{{ formatNumber(indicateurs.sumTelereglementTraite) }} €</span>
                </div>
              </b-card>
            </b-col>
            <b-col class="md-3 sm-12">
              <b-card>
                <div class="callout callout-warning">
                  <strong class="text-muted">Chèques encaissés sur {{ new Date().getFullYear() }}</strong><br>
                    <span class="text-muted">Traités : </span><span class="h5">{{ formatNumber(indicateurs.countChequeTraite) }}</span><br>
                    <span class="text-muted">Montant : </span><span class="h5 text-nowrap">{{ formatNumber(indicateurs.sumChequeTraite) }} €</span>
                </div>
              </b-card>
            </b-col>
            <b-col class="md-3 sm-12">
              <b-card>
                <div class="callout callout-danger">
                  <strong class="text-muted">Total encaissé sur {{ new Date().getFullYear() }}</strong><br>
                   <span class="text-muted">Traités : </span>
                    <span class="h5">
                      {{ formatNumber(indicateurs.countVirementTraite + indicateurs.countTelereglementTraite + indicateurs.countChequeTraite)}}
                    </span><br>
                    <span class="text-muted">Montant : </span><span class="h5 text-nowrap">{{ formatNumber(sumTotal.toFixed(2)) }} €</span>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceRPARules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceRPARules,
      indicateurs: []
    }
  },
  computed : {
    sumTotal: function(){
        return parseFloat(this.indicateurs.sumVirementTraite) + parseFloat(this.indicateurs.sumTelereglementTraite) + parseFloat(this.indicateurs.sumChequeTraite);
      }
  },
  mounted() {
  this.getIndicateurs();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    getIndicateurs() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/accueil")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.indicateurs = response.data.indicateurs;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    formatNumber(num) {
      if(num != null){
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(/\./g, ',');
      }
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    }
  }
}
</script>